import { Injectable } from '@angular/core';
import { ProviderSpot, ProviderSpotDto } from '../../models/provider-parking/provider-spot.model';

@Injectable({
    providedIn: 'root',
})
export class MapperProviderSpotService {
    
    /** 
     * Map Data From API (DTO) to Logical Model (ProviderSpot) 
     */
    public mapProviderSpotFromDto(dto: ProviderSpotDto): ProviderSpot {
        return {
            id: dto.Id || 0,
            name: dto.GateName || '',
            description: dto.GateDescription || '',
            posId: dto.POSID || '',
            ip: dto.GateIP || '',
            spotType: dto.TypeGateName || '',
            area: dto.AreaName || '',
            vehicleType: dto.VehicleTypeName || '',
            apiUser: dto.GateUserApi || '',
            apiPass: dto.GatePassApi || '',
            connectDate: dto.ConnectDate || '',
            monitor: dto.Monitor || '',
            status: dto.Status || '',
            deviceKey: dto.DeviceKey || '',
            defaultRate: dto.DefaultRate || '',
            prefix: dto.Prefix || '',
            sapName: dto.SapName || '',
            sapNameM: dto.SapNameM || '',
            site: dto.Site || '',
            checkCode: dto.CheckCode || ''
        };
    }

    /** 
     * Map Logical Model (ProviderSpot) back to API (DTO) 
     */
    public mapProviderSpotToDto(model: ProviderSpot): ProviderSpotDto {
        return {
            Id: model.id,
            GateName: model.name,
            GateDescription: model.description,
            POSID: model.posId,
            GateIP: model.ip,
            TypeGateName: model.spotType,
            AreaName: model.area,
            VehicleTypeName: model.vehicleType,
            GateUserApi: model.apiUser,
            GatePassApi: model.apiPass,
            ConnectDate: model.connectDate,
            Monitor: model.monitor,
            Status: model.status,
            DeviceKey: model.deviceKey,
            DefaultRate: model.defaultRate,
            Prefix: model.prefix,
            SapName: model.sapName,
            SapNameM: model.sapNameM,
            Site: model.site,
            CheckCode: model.checkCode
        };
    }
}
